import type { TrainingMajor } from '../../../../../index';
import getHelper from '../../../services/getHelper';

export default getHelper<TrainingMajor>('/training-majors/:id');
